import React from 'react';

export const EventSkeleton = () => {
  return (
    <div className="animate-pulse w-full flex flex-wrap mt-4 gap-[64px] md:gap-[100px]">
      <div className="w-full h-[500px] rounded-[20px] overflow-hidden relative bg-mbgray-100 aspect-video"></div>
      <div className="w-full flex flex-col justify-between justify-between gap-[64px] lg:flex-row">
        <div className="w-full flex flex-col gap-8 self-stretch lg:w-1/2">
          <div className="w-full max-w-[300px] h-9 rounded-[36px] bg-mbgray-100"></div>
          <div className="w-full h-[300px] bg-mbgray-100 rounded-[36px]"></div>
        </div>
        <div className="w-full h-[300px] lg:w-[427px] bg-mbgray-100 rounded-[36px]"></div>
      </div>
    </div>
  );
};
